function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { Collector } from "@dp/byted-tea-sdk-oversea";
import { Region, SDK_BID, VERSION } from "../constants/env";
const getTeaRegionalConfig = (region) => {
  let defaultConfig = {};
  switch (region) {
    case Region.US_EASTRED: {
      defaultConfig = {
        channel: "in",
        channel_type: "tcpy",
        channel_domain: "https://mcs16-normal-useastred.tiktokw.eu"
      };
      break;
    }
    case Region.EU_TTP: {
      defaultConfig = {
        channel: "ie",
        channel_type: "ttp",
        channel_domain: "https://mcs-ie.tiktokw.eu"
      };
      break;
    }
    case Region.EU_TTP2: {
      defaultConfig = {
        channel: "ie2",
        channel_type: "ttp",
        channel_domain: "https://mcs-ie2.tiktokw.eu"
      };
      break;
    }
    case Region.US_TTP: {
      defaultConfig = {
        channel_type: "ttp",
        channel_domain: "https://mcs.tiktokv.us"
      };
      break;
    }
    case Region.US_TTP2: {
      defaultConfig = {
        channel_type: "ttp",
        channel_domain: "https://mcs.tiktokw.us"
      };
      break;
    }
    case Region.SINGAPORE_CENTRAL: {
      defaultConfig = {
        channel: "sg",
        channel_type: "tcpy",
        channel_domain: "https://mcs-sg.tiktokv.com"
      };
      break;
    }
    case Region.US_EAST: {
      defaultConfig = {
        channel: "va",
        channel_type: "tcpy",
        channel_domain: "https://mcs-va.tiktokv.com"
      };
      break;
    }
    default:
      break;
  }
  return defaultConfig;
};
const hasValidConfig = (config) => {
  return !!(config && config.channel_type && (config.channel || config.channel_domain));
};
const createTeaAndInit = (config, sdkContext) => {
  let teaInstance = null;
  if ((config === null || config === void 0 ? void 0 : config.tea) !== false) {
    try {
      const { tea } = config !== null && config !== void 0 ? config : {};
      const { appId, region, debug } = sdkContext !== null && sdkContext !== void 0 ? sdkContext : {};
      const defaultConfig = getTeaRegionalConfig(region);
      const finalConfig = _object_spread({}, defaultConfig, tea !== null && tea !== void 0 ? tea : {});
      if (appId && hasValidConfig(finalConfig)) {
        teaInstance = new Collector(`${SDK_BID}_${VERSION}_${Date.now()}`);
        teaInstance.init(_object_spread_props(_object_spread({}, finalConfig), {
          app_id: appId,
          log: debug,
          enable_debug: debug
        }));
        teaInstance.start();
      }
    } catch (e) {
    }
  }
  return teaInstance;
};
export {
  createTeaAndInit,
  getTeaRegionalConfig,
  hasValidConfig
};

//# sourceMappingURL=TeaUtil.js.map